// import { epicsList } from '../../constants/epics.index'

import axiosNew from '../../../../../helpers/axios'

// GET TEST CASE LIST
export const apiDownloadSampleDoc = (payload) => {
    return new Promise(async (resolve) => {
        try {
            const resp = await axiosNew({
                url: `/testcase/download-template`,
                method: 'get',
                responseType: 'blob',
            })

            resolve({ data: resp ?? {} })
        } catch (error) {
            resolve({ data: error?.response?.data ?? {} })
        }
    })
}

// CREATE TEST CASE
export const apiImportTestCases = (payload) => {
    return new Promise(async (resolve) => {
        try {
            let data = payload ?? {}
            const createEpicData = await axiosNew({
                url: '/testcase/upload',
                method: 'post',
                data,
            })
            resolve({ data: createEpicData?.data ?? {} })
        } catch (error) {
            resolve({ data: error?.response?.data ?? {} })
        }
    })
}
